import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { MonthEndStockItemHeader, MonthEndStockItemSearchResult } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class MonthEndStockItemHeaderService extends TmsWebBaseEditService<
  MonthEndStockItemHeader,
  MonthEndStockItemHeader
> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('MonthEndStockItemHeader', $localize`Month End Stock`);
  }

  getMonthEndStockItems(id: string): Observable<MonthEndStockItemSearchResult> {
    return this.httpService.get<MonthEndStockItemSearchResult>(`${this.apiUrl}/GetMonthEndStockItems?id=${id}`);
  }

  freezeMonthEndStock(): Observable<any> {
    return this.httpService.post(`${this.apiUrl}/FreezeMonthEndStock`, '');
  }
}
